export default __webpack_public_path__ + "static/media/octahedron.9818d47d.png";